
import './Loginadmin.css';
import logo from '../../logo.png'
import axios from "axios";
import { useEffect, useState } from "react";
import { PasswordInput, TextInput, Button} from '@mantine/core';
import { useForm } from '@mantine/form';
import { useNavigate } from "react-router-dom";
import { IconUser } from "@tabler/icons-react";
import { setMemoryToken, setProfile } from "../../auth/session";

const base_url = process.env.REACT_APP_BASE_URL;
export default function Loginadmin() {
  const [userRole, setRole] = useState(localStorage.getItem("userroleAdmin"))
  const [authed, setAuthed] = useState(!!localStorage.getItem("userroleAdmin"))
  const navigate = useNavigate();
  const [email, setEmail] = useState()
  const [password, setPassword] = useState()
  const [error, setErr] = useState(null);

  const handleSubmit = e => {
    e.preventDefault()
    axios({
      method: "post",
      data: { "email": email, "password": password},
      url: base_url+"/admin/login-users",
      withCredentials: true,
    }).then((response) => {
        if (response.data.status !== 200 || !response.data.token) {
          setErr(400);
          return;
        }
        setMemoryToken("userAdmin", response.data.token);
        setProfile({
          uuid: response.data.uuid,
          role: response.data.role,
          firstname: response.data.firstname,
        }, { admin: true });
        setRole(response.data.role)
        setAuthed(true)
        setErr(null);
      }).catch(() => {
        setErr(400);
      });
  }

  useEffect(() => {
    if (authed && userRole === 'Database Admin') {
      navigate("/Managemeal")
    }
  }, [authed, userRole, navigate])

  const form = useForm({
    initialValues: { email: '', password: ''},
    validateInputOnBlur: true,
    validateInputOnChange: true,
    validate: {
      email: (value) => (/^\S+@\S+$/.test(value) ? setEmail(value) : 'Invalid email'),
      password: (value) => (value.length < 7 ? 'Password should be minimum 8 digit to Login' : setPassword(value)),
    },
})

  return(
    <div className='login-wrapper'>
      <div className='leftside'>
      <div className='logo'><img alt="iWel" src={logo}></img>
        <h3>Digital Health & Wellness Management</h3>
      </div>

    <form action="" id="login" method="post" onSubmit={handleSubmit}>
   {error === 400 ? (<div className="item error">Invalid Email and Password!</div>) : ''}
        <div className="item">
          <TextInput
            id="email"
            onChange={e => setEmail(e.target.value)} placeholder="Email Address" {...form.getInputProps('email')}  rightSection={<IconUser size={16} />}
          />
        </div>
        <div className="item">
          <PasswordInput
            id="password" autoComplete=''
            onChange={e => setPassword(e.target.value)} placeholder="Password"  {...form.getInputProps('password')}
          />
        </div>
        <div className="item">
          <Button type="submit" className="submit-btn">Log in</Button>
        </div>
      </form>
    </div>
    <div className='rightside'></div>
    </div>
  )
}
